import { useEffect, useState } from 'react';

/**
 * Hook para recibir y aplicar cambios de fontSize desde ACV App mediante postMessage
 * Aplica el fontSize al document.documentElement y establece la variable CSS --font-scale
 */
export function useFontSize() {
  const [fontSize, setFontSize] = useState(() => {
    // Cargar desde localStorage si existe
    if (typeof window !== 'undefined') {
      try {
        const saved = localStorage.getItem('acv:fontSize');
        if (saved) {
          const parsed = parseInt(saved, 10);
          if (!isNaN(parsed) && parsed >= 70 && parsed <= 130) {
            return parsed;
          }
        }
      } catch (e) {
        console.warn('[useFontSize] Error loading from localStorage:', e);
      }
    }
    return 100; // Default
  });

  useEffect(() => {
    // Aplicar fontSize inicial
    const applyFontSize = (size: number) => {
      const root = document.documentElement;
      root.style.fontSize = `${size}%`;
      root.style.setProperty('--font-scale', String(size / 100));
    };

    // Aplicar fontSize inicial
    applyFontSize(fontSize);

    // Listener para recibir cambios desde ACV App
    const handleMessage = (event: MessageEvent) => {
      // Verificar que el mensaje es del tipo correcto
      if (event.data && event.data.type === 'font-size-change') {
        const newFontSize = event.data.fontSize;
        if (typeof newFontSize === 'number' && newFontSize >= 70 && newFontSize <= 130) {
          console.log('[useFontSize] 📥 FontSize recibido desde ACV:', newFontSize);
          setFontSize(newFontSize);
          
          // Guardar en localStorage
          try {
            localStorage.setItem('acv:fontSize', String(newFontSize));
          } catch (e) {
            console.warn('[useFontSize] Error saving to localStorage:', e);
          }
        }
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [fontSize]);

  // Aplicar fontSize cuando cambie
  useEffect(() => {
    const root = document.documentElement;
    root.style.fontSize = `${fontSize}%`;
    root.style.setProperty('--font-scale', String(fontSize / 100));
  }, [fontSize]);

  return fontSize;
}

